import React, { useContext, useState, useMemo, useEffect } from "react";
import styles from "./styles.module.scss";
import AppContext from "../../hooks/appContext";
import debounce from 'lodash.debounce';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const FilterCard = (props) => {

  const {
    allStoreCategories,
    currentCategory,
    setCurrentCategory,
    filterParams,
    setFilterParams,
    priceFilterAmount,
    setPriceFilterAmount,
    thisStoreProducts,
    currentCurrency,
  } = useContext(AppContext);


  const [currentHighestAmount, setCurrentHighestAmount] = useState(20000);
  const highestPrice = () => {
    let highestAmount = 0;

    props.allProducts?.forEach((product) => {
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach((variant) => {
          variant.amounts.forEach((amount) => {
            if (amount.currency_id === currentCurrency && parseFloat(amount.amount) > highestAmount) {
              highestAmount = parseFloat(amount.amount);
            }
          });
        });
      } else {
        product.amounts.forEach((amount) => {
          if (amount.currency_id === currentCurrency && parseFloat(amount.amount) > highestAmount) {
            highestAmount = parseFloat(amount.amount);
          }
        });
      }
    });

    setCurrentHighestAmount(highestAmount);
  }

  useEffect(() => {
    highestPrice();
  }, [])

  const options = [
    {value: "none", label: "Sort By"},
    {value: "ASC", label: "Price: Low to High"},
    {value: 'DESC', label: "Price: High to Low"},
  ]

  const handleCategoryClick = (category) => {
    setCurrentCategory(category);

    if (category === "all") {
      setFilterParams({ ...filterParams, category: "" });
    } else {
      setFilterParams({ ...filterParams, category: category });
    }
  }

  const handleChangeSortOrder = (order) => {
    if (order === "ASC") {
      setFilterParams({ ...filterParams, priceOrder: "ASC" })
    } else if (order === "DESC") {
      setFilterParams({ ...filterParams, priceOrder: "DESC" })
    } else if (order === "none") {
      setFilterParams({ ...filterParams, priceOrder: null })
    }

  }

  const handleChangePriceRange = (price) => {
    debouncedPriceRangeHandler(priceFilterAmount);
  }

  const handlePriceRangeFilter = (price) => {
    setFilterParams({ ...filterParams, priceRange: price })
  }

  const debouncedPriceRangeHandler = useMemo(
    (price) => debounce(handlePriceRangeFilter, 400)
  , []);

  function ValueLabelComponent(props) {
    const { children, value } = props;
  
    return (
      <Tooltip enterTouchDelay={0} placement="top" title={value}>
        {children}
      </Tooltip>
    );
  }

  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
  };

  const formatFilterAmount = (amount) => {
    const formattedNumber = amount.toLocaleString('en-NG', { style: 'currency', currency: 'NGN' });
    return formattedNumber;
  }

  const allCategoryClasses = `${styles.category} ${currentCategory === 'all' ? styles.active : ""}`

  useEffect(() => {
    let highestAmount = 0;

    thisStoreProducts?.forEach((product) => {
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach((variant) => {
          variant.amounts.forEach((amount) => {
            if (amount.currency_id === currentCurrency && parseFloat(amount.amount) > highestAmount) {
              highestAmount = parseFloat(amount.amount);
            }
          });
        });
      } else {
        product.amounts.forEach((amount) => {
          if (amount.currency_id === currentCurrency && parseFloat(amount.amount) > highestAmount) {
            highestAmount = parseFloat(amount.amount);
          }
        });
      }
    });

    setCurrentHighestAmount(highestAmount / 100)
  }, [thisStoreProducts]);

  return (
    <>
      <div className={styles['filter-card']}>
        <div className={styles['filter-card-body']}>
          <div className={styles['sort-filter']}>
            <div className={styles['filter-title']}>Sort By</div>
            
            <select name="order-select" className={styles['order-select']} value={filterParams?.priceOrder || "none"} onChange={(e) => handleChangeSortOrder(e.target.value)}>
              {
                options.map((option, id) => (
                  <option value={option.value} key={id}>{option.label}</option>
                ))
              }
            </select>
          </div>

          <div className={styles['category-filter']}>
            <div className={styles['filter-title']}>Product Categories</div>
            <div className={styles['title-divider']}></div>
            <div className={styles['category-list']}>
              <div className={allCategoryClasses} onClick={() => handleCategoryClick("all")}>All</div>
              {
                allStoreCategories?.map((cat, id) => (
                  <div className={`${styles.category} ${currentCategory.toLowerCase() === cat.slug.toLowerCase() ? styles.active : ""}`}
                    key={id}
                    onClick={() => handleCategoryClick(cat.slug)}>
                    {cat.name}
                  </div>
                ))
              }
            </div>
          </div>

          <div className={styles['price-filter']}>
            <div className={styles['price_filter_title']}>
              <p className={styles['filter_label']}>Price </p>
              <p className={styles['filter_value']} onClick={() => handleChangePriceRange()}>Apply</p>
            </div>
            <div className={styles['title-divider']}></div>

            <Slider
              valueLabelDisplay="auto"
              slots={{
                valueLabel: ValueLabelComponent,
              }}
              defaultValue={priceFilterAmount}
              onChange={(e) => setPriceFilterAmount(e.target.value)}
              step={100}
              min={0}
              max={currentHighestAmount}
              sx={{ color: "#e51e56" }}
            />

            <div className={styles['filter-label']}>
              <p className={styles['price-label']}>{formatFilterAmount(0)} - {priceFilterAmount ? formatFilterAmount(priceFilterAmount) : ""}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FilterCard;